import { useState } from 'react'

import Button from '../Button'

interface MemoryComposerProps {
  onSubmit: (text: string) => void
  disabled?: boolean
}

/**
 * Records a memory typed directly by a person. The backend still runs it
 * through extraction, so a rambling note becomes discrete facts.
 */
export function MemoryComposer({ onSubmit, disabled }: MemoryComposerProps) {
  const [text, setText] = useState('')

  return (
    <form
      className="space-y-2"
      onSubmit={(event) => {
        event.preventDefault()
        if (!text.trim()) return
        onSubmit(text.trim())
        setText('')
      }}
    >
      <textarea
        className="w-full rounded-lg border border-harbor-border bg-harbor-surface-raised p-2 text-sm text-harbor-text placeholder-harbor-text-muted focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
        placeholder="Record a decision, preference or constraint…"
        value={text}
        onChange={(event) => setText(event.target.value)}
        aria-label="New memory"
        disabled={disabled}
      />
      <Button type="submit" size="sm" disabled={disabled || !text.trim()}>
        Remember
      </Button>
    </form>
  )
}
